import React from "react"
import ContentLoader from "react-content-loader"

const ResponsiveLoading = (props) => {
  return (
    <ContentLoader viewBox="0 0 100% 220" height={220} width={"100%"} {...props}>
      <rect x="0" y="0" rx="5" ry="5" width="40%" height="20" />
      <rect x="0" y="42" rx="5" ry="5" width="100%" height="200" />
    </ContentLoader>
  )
}

export const Loading = ({ cWidth, cHeight, bColor, fColor }) => {

  return (
    <ContentLoader viewBox={`0 0 ${cWidth} ${cHeight}`} width={cWidth} height={cHeight}
      backgroundColor={bColor}
      foregroundColor={fColor}
    >
      <rect x={0} y={0} rx="5" ry="5" width={cWidth} height={cHeight} />
    </ContentLoader>
  )
}

export const TableLoading = ({ loop, multiply, cHeight, viewBoxHeight }) => {
  const array = new Array(loop);

  for (let i = 0; i < array.length; i++) {
    array[i] = i + 1;
  }
  return (
    <ContentLoader viewBox={`0 0 400 ${viewBoxHeight}`} >
      {array.map((item, key) => (
        <rect key={key} x="5" y={item * multiply} rx="5" ry="5" width="390" height={cHeight} />
      ))}
    </ContentLoader>
  );
}
ResponsiveLoading.metadata = {
  name: "Ashiru Olawale", // My name
  github: "walebant", // Github username
  description: "A responsive article loader that fits every screen 🎉", // Little tagline
  filename: "ResponsiveArticle" // filename of your loader
}

export default ResponsiveLoading